import React from 'react';
import ReactDOM from 'react-dom/client';

import { GlobalStyle } from './styles';
import { App } from './App';
import { StateContextProvider, GoogleMapsContextProvider } from './context';
import { loadGoogleMaps } from './utils';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

loadGoogleMaps().then(() => {
    root.render(
        <React.StrictMode>
            <StateContextProvider>
                <GoogleMapsContextProvider>
                    <GlobalStyle />
                    <App />
                </GoogleMapsContextProvider>
            </StateContextProvider>
        </React.StrictMode>
    );
});
